import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { GenericInputModule } from '@sla-ng/ui-material';
import { GeneratePlanningModule } from '../../../components/generate-planning/generate-planning.module';
import { PlannedPurchasePricePage } from './planned-purchase-price-page';
import { PlannedPurchasePriceDialogModule } from './planned-purchase-price-dialog/planned-purchase-price-dialog.module';

export * from './planned-purchase-price-page';
export * from './planned-purchase-price-dialog/planned-purchase-price-dialog.module';

const routes: Routes = [
    {
        path: '',
        component: PlannedPurchasePricePage,
    },
];

@NgModule({
    providers: [
        DatePipe,
    ],
    declarations: [
        PlannedPurchasePricePage,
    ],
    imports: [
        PlannedPurchasePriceDialogModule,
        GeneratePlanningModule,
        CommonModule,
        RouterModule.forChild(routes),
        MatProgressBarModule,
        MatTableModule,
        TranslateModule,
        MatButtonModule,
        MatIconModule,
        FormsModule,
        MatSortModule,
        MatMomentDateModule,
        MatFormFieldModule,
        MatDatepickerModule,
        ReactiveFormsModule,
        GenericInputModule,
        MatPaginatorModule,
        MatTooltipModule,
        MatInputModule,
    ],
})
export class PlannedPurchasePricePageModule {
}
